import React, { Component } from 'react';
// import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';

class ProfilePage extends Component {
  state = {

  }

  handleChange = (ev) => {
    const name = ev.target.name;
    const value = ev.target.value;

    this.setState({ [name]: value })
  }

  handleImage = (ev) => {
    const file = ev.target.files[0];
    if (file) {
      const url = window.URL.createObjectURL(file);
      this.setState({ image: url })
    }
  }

  render() {
    return (
      <div className="profile container content">
        <h2>Profile</h2>
        <input type="text" className="input" 
          name="firstName"
          placeholder="First Name"
          value={this.state.firstName}
          onChange={this.handleChange} />
        <input type="text" className="input" 
          name="lastName"
          placeholder="Last Name"
          value={this.state.lastName}
          onChange={this.handleChange} />
        <input type="text" className="input" 
          name="address"
          placeholder="Address"
          value={this.state.address}
          onChange={this.handleChange} />
        <input type="text" className="input" 
          name="email"
          placeholder="Email"
          value={this.state.email}
          onChange={this.handleChange} />
        <input type="text" className="input" 
          name="phone"
          placeholder="Phone"
          value={this.state.phone}
          onChange={this.handleChange} />
        <input type="text" className="input" 
          name="companyName"
          placeholder="Company Name"
          value={this.state.companyName}
          onChange={this.handleChange} />
        <input type="text" className="input" 
          name="companyWebsite"
          placeholder="Company Website"
          value={this.state.companyWebsite}
          onChange={this.handleChange} />
        <select type="text" className="input" 
          name="industry"
          placeholder="Industry"
          value={this.state.industry}
          onChange={this.handleChange}>
          <option value="">Please Select</option>
          <option value="text">Booking Agent</option>
          <option value="text">Event Promoter</option>
          <option value="text">Ticketing Company</option>
          <option value="text">Media Agency</option>
          <option value="text">Artist Manager</option>
          <option value="text">Musician / Artist</option>
          <option value="text">Record Label</option>
          <option value="text">Ad Network</option>
          <option value="text">Venue</option>
          <option value="text">Fair / Festival</option>
          <option value="text">Other</option>
        </select>
        <input type="password" className="input" 
          name="newPassword"
          placeholder="New Password"
          value={this.state.newPassword}
          onChange={this.handleChange} />
        <input type="password" className="input" 
          name="newPasswordConfirm"
          placeholder="Confirm New Password"
          value={this.state.newPasswordConfirm}
          onChange={this.handleChange} />
        <button className="button">Save</button>
      </div>
    );
  }
}

export default ProfilePage;


// WEBPACK FOOTER //
// ./src/components/ProfilePage.js